export const preguntaState = {
    grupos: [],
    preguntas: [],
    respuestas: [],
    dependencias: [],
    excluyentes: [],
    isLoading: false,
    message: '',
    severity: '',
    isComplete: false,
    existe_observacion: false
}